import React from 'react';
import '../styles/Footer.css';

import pdf from '../Resume_SrivatsanV.pdf';

export default function Footer() {
  return (
    <div>
      <footer>
        <div className="footer-wrap">
          <div className="left">
            <div className="location">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="fas fa-map-marker"></i>
                <div>
                  Mega Tower 3, NITK <br /> Mangalore, India
                </div>
              </div>
            </div>
            <div className="phone">
              <div>
                <i className="fas fa-phone"></i>+91 8431993581
              </div>
            </div>
            <div className="mail">
              <div>
                <i className="fas fa-envelope"></i>srivi567@gmail.com
              </div>
            </div>
          </div>

          <div className="right">
            <a
              href={pdf}
              className="link-resume"
              target="_blank"
              rel="noopener noreferrer"
            >
              RESUME
            </a>
            <div className="footer-icons">
              <a
                href="https://www.linkedin.com/in/srivatsan-v-8aaa88152/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://www.github.com/SrivatsanV"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-github"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
